import api from './api';
import { CPB_URL } from './servers';

export const axiosDataCatalogoFiltrosBeneficiados = (payload) =>
  api.post(`${CPB_URL}/identificaSO/getCatFiltros`, payload);

export const axiosDataCatalogoSOAprobados = (payload) =>
  api.post(`${CPB_URL}/identificaSO/getCatFiltros`, payload);

export const axiosDataTableBeneficiados = (payload) =>
  api.post(`${CPB_URL}/identificaSO/getBeneficiadosCaptManual`, payload);

export const axiosDataTableSOAprobados = (payload) =>
  api.post(`${CPB_URL}/identificaSO/getCandidatosSOAprobadoSIF`, payload);

export const axiosActualizarSujetosObligados = (payload) =>
  api.post(`${CPB_URL}/identificaSO/actualizarSujetosSIMAC`, payload);
